export enum VideoLayout2Theme {
  BLUE = 'BLUE',
  RED = 'RED',
  OPAL = 'OPAL',
}
